<template>
  <div class="slideContainter">
    <div class="customer-prev slideButton" slot="button-prev">
      <span class="leftSingle single cursorPointer"></span>
    </div>
    <swiper :options="swiperOption" class="swiperCustomer cursorPointer" v-if="contractList.length">
      <swiper-slide class="swiperSlidecustomer" v-for="(item,index) in contractList" :key="index">
        <div>
          <div class="content">
            <img :src="item.thumbPath">
          </div>
          <img class="cover" @click="previewPdf(item)" src="@image/personalSign/preview_icon.png">
          <div class="coverDscp">
            <p class="ellipsis ft12">{{item.fileName}}</p>
            <div class="handlerBox">
              <div>{{item.pages}}页</div>
              <el-tooltip placement="bottom" effect="light" popper-class="signPopperHandler">
                <div class="dotBox">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
                <div slot="content" class="conterntBox cursorPointer">
                  <div @click="deleteContract(item,index)">删除</div>
                  <div @click="reNameContract(item,index)">重命名</div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiperSlidecustomerAdd" slot="upload">
      <div v-loading="loadingUpload">
        <div class="content">
          <img src="@image/personalSign/pdf_file_icon.png">
        </div>
        <upload
          :url="'/file/uploadContract'"
          class="cover"
          :uploadType="'contract'"
          :curCount="contractList.length"
          @uploadSuccess="upload"
          @loading="loadingUpload=true"
          @loadingEnd="loadingUpload=false"
        >
          <img src="@image/personalSign/Addcontract_img_hov_pre.png" slot="uploadContent">
        </upload>
        <div class="coverDscp">上传本地文件</div>
      </div>
    </div>
    <div class="customer-next slideButton" slot="button-next">
      <span class="rightSingle single cursorPointer"></span>
    </div>
    <slot name="other"></slot>
    <Dialog
      :visible="deleteDialogShow"
      :dialogTitle="'提示'"
      :width="'400px'"
      @closeDialog="closeDialog('deleteDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>此操作将删除合同文件，是否继续？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button buttonActive cursorPointer" @click="closeDialog('deleteDialogShow')">取消</div>
          <div class="button cursorPointer" @click="deleteContractConfrim">确定</div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="renameDialogShow"
      :dialogTitle="'合同文件重命名'"
      :width="'400px'"
      @closeDialog="closeDialog('renameDialogShow')"
    >
      <div class="signDialogs" slot="dialog">
        <div class="authDscp withInput">
          <p>请输入合同名称：</p>
          <el-input v-model="contractName" maxlength="50"></el-input>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="closeDialog('renameDialogShow')">取消</div>
          <div class="button cursorPointer buttonActive" @click="renameConfrim">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Upload from "@common/upload.vue";
import "swiper/dist/css/swiper.css";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
export default {
  props: {
    state: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      loadingUpload: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 35,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".customer-prev",
          prevEl: ".customer-next"
        }
      },
      contractName: "",
      deleteDialogShow: false,
      renameDialogShow: false,
      currentItem: {},
      currentIndex: 0,
      contractList: []
    };
  },
  components: {
    swiper,
    swiperSlide,
    Upload,
    Dialog
  },
  mounted() {},
  methods: {
    closeDialog(flag) {
      this.contractName = "";
      this[flag] = false;
    },
    setData(data) {
      this.contractList = data;
      this.getPDFpags();
    },
    deleteContractConfrim() {
      console.log("删除的id" ,this.currentItem.id)
      BaseApi.createRpcToken(
        "/file/delete",
        { id: this.currentItem.id },
        "post"
      ).then(
        data => {
          this.contractList.splice(this.currentIndex, 1);
          this.deleteDialogShow = false;
          this.$message.success("删除成功");
        },
        () => {}
      );
    },
    renameConfrim() {
      if (!this.contractName) {
        this.$message.error('请输入合同名称');
        return;
      }
      BaseApi.createRpcToken(
        "/file/rename",
        {
          id: this.currentItem.id,
          fileName: this.contractName
        },
        "post"
      )
        .then(
          data => {
            this.renameDialogShow = false;
            this.$set(this.currentItem, "fileName", this.contractName);
            this.$message.success("重命名成功");
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    deleteContract(item, index) {
      console.log(item)
      this.currentItem = item;
      this.currentIndex = index;
      this.deleteDialogShow = true;
    },
    reNameContract(item, index) {
      this.currentItem = item;
      this.currentIndex = index;
      this.renameDialogShow = true;
    },
    upload(item) {
      this.contractList.push(item.datas.fileInfo);
      this.getPDFpags();
    },
    previewPdf(item) {
      this.$Method.previewPdf(item.filePath);
    },
    getPDFpags(){
      let _this=this;
      this.contractList.forEach( function (item,index){
         PDFJS.getDocument({ url: item.filePath }).then( function getPdfHelloWorld(pdf) {
            _this.totalPage=pdf.numPages;
             item.pages=pdf.numPages;
           _this.contractList.splice(index,1,item)
         })
      })
    },
    save() {
      let arrTemp = [];
      this.contractList.map(function(value) {
        arrTemp.push(value.id);
      });
      if (arrTemp.length) {
        return {
          data: arrTemp,
          valid: true
        };
      } else {
        return {
          data: [],
          valid: false,
          validMessage: "至少选择一个合同文件"
        };
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signPopperHandler {
  width: 80px;
  padding: 0 !important;
  background: #ffffff;
  border: 1px solid #e4e8eb !important;
  box-shadow: 0 1px 1px 0 rgba(160, 160, 160, 0.5) !important;
  .conterntBox {
    div {
      line-height: 30px;
      text-align: align;
      color: #e88078;
      font-size: 14px;
      text-align: center;
    }
    & > div:first-child {
      border-bottom: 1px solid #e4e8eb;
    }
  }
}
.slideContainter {
  width: 100%;
  height: 100%;
  display: flex;
  .swiperCustomer {
    // flex: 1;
    max-width: calc(100% - 500px);
    margin: 0;
    .swiperSlidecustomer {
      margin: 0;
      width: 160px;
      height: 200px;
      position: relative;
      .content {
        width: 100%;
        height: 200px;
        box-sizing: border-box;
        padding: 10px;
        background-color: #f4f4f4;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .cover {
        display: none;
      }
      &:hover {
        .cover {
          position: absolute;
          display: block;
          width: 100%;
          height: 146px;
          left: 0;
          top: 0;
          z-index: 1;
        }
      }
      .coverDscp {
        position: absolute;
        z-index: 2;
        width: 160px;
        box-sizing: border-box;
        height: 55px;
        bottom: 0;
        padding: 5px;
        border: 1px solid #e4e8eb;
        background-color: white;
        p {
          line-height: 17px;
          color: #646464;
        }
        .handlerBox {
          margin-top: 5px;
          height: 17px;
          line-height: 17px;
          display: flex;
          color: #969696;
          font-size: 12px;
          justify-content: space-between;
          .dotBox {
            height: 20px;
            width: 3px;
            .dot {
              margin-bottom: 3px;
              height: 3px;
              width: 3px;
              background-color: #e88078;
            }
          }
        }
      }
    }
  }
  .slideButton {
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .single {
      width: 11px;
      height: 17px;
      background-size: 100% 100%;
    }
    .rightSingle {
      background: url(./../../../../../assets/images/personalSign/right_icon_nor.png);
      &:hover {
        background: url(./../../../../../assets/images/personalSign/right_icon_hov.png);
      }
    }
    .leftSingle {
      background: url(./../../../../../assets/images/personalSign/left_icon_nor.png);
      &:hover {
        background: url(./../../../../../assets/images/personalSign/left_icon_hov.png);
      }
    }
  }
}
</style>
